import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5340a4f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-wild-sand p-x3 mb-x6 mx-auto max-w-750" }
const _hoisted_2 = { class: "text-12" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center mt-x3"
}
const _hoisted_4 = ["onClick"]

import {
    BaseProductItem,
    CheckoutDeliverableType,
    CheckOutDeliverable,
    CheckOutDeliverableWithAddress,
    CustomerDeliveryCheckOutDeliverable, EarliestCustomerDeliveryDates, LabelWithNamedArguments,
} from '@/b2b/shared/api/server-apis';
import { computed, ref } from 'vue';
import type { Component } from 'vue';
import CheckoutItem from '../items/CheckoutItem.vue';
import CheckoutItemSkeleton from '../items/CheckoutItemSkeleton.vue';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useDeliverableLineItems } from '@/b2b/checkout/useDeliverableLineItems';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliverableItems',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CheckOutDeliverable | CheckOutDeliverableWithAddress | CustomerDeliveryCheckOutDeliverable;
}



const labels = useBlockLabels();
const { deliveryInfo } = useCheckout();
const { deliverableLineItemsSortedByDeliveryDate } = useDeliverableLineItems();

const itemCap = 6;
const itemCapActive = ref<boolean>(true);

const relatedDeliveryInfo = computed<EarliestCustomerDeliveryDates>(() => {
    return deliveryInfo.value[props.deliverable.id];
});

const skeletonOrItemComponent = computed<Component>(() => waitingForDeliveryInfo.value ? CheckoutItemSkeleton : CheckoutItem);

const sortedLineItems = computed<BaseProductItem[]>(() => deliverableLineItemsSortedByDeliveryDate(props.deliverable));
const showToggleItemCap = computed<boolean>(() => sortedLineItems.value.length > itemCap);
const maybeCappedSortedLineItems = computed<BaseProductItem[]>(() => {
    if (showToggleItemCap.value && itemCapActive.value) {
        return sortedLineItems.value.slice(0, itemCap);
    } else {
        return sortedLineItems.value;
    }
});

const waitingForDeliveryInfo = computed<boolean>(() => props.deliverable.type === CheckoutDeliverableType.CustomerDelivery && !relatedDeliveryInfo.value);

const getItemLabelByItemId = (id: number) => {
    const itemLabel = relatedDeliveryInfo.value?.labelForItems?.find((label) => label.itemId === id);
    return itemLabel?.label ?? {} as LabelWithNamedArguments;
};

const toggleItemCapActive = () => {
    itemCapActive.value = !itemCapActive.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'flex justify-center': _unref(sortedLineItems).length === 1, 'grid grid-cols-1 md:grid-cols-2 gap-y-x3 sm:gap-x-x4 sm:gap-y-x4': _unref(sortedLineItems).length > 1})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maybeCappedSortedLineItems), (item) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(skeletonOrItemComponent)), {
          key: item.id,
          item: item,
          class: "flex"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BlockLabelWithNamedArguments, {
                label: getItemLabelByItemId(item.id)
              }, null, 8, ["label"])
            ])
          ]),
          _: 2
        }, 1032, ["item"]))
      }), 128))
    ], 2),
    (_unref(showToggleItemCap) && !_unref(waitingForDeliveryInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_Transition, {
            name: "o-anim-fade-300",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("button", {
                key: itemCapActive.value,
                class: "c-magic-line c-magic-line--underline",
                onClick: _withModifiers(toggleItemCapActive, ["prevent"])
              }, [
                (itemCapActive.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).deliverableItemsShowAllItems, {quantity: _unref(sortedLineItems).length.toString()})), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).deliverableItemsHideAllItems, {quantity: (_unref(sortedLineItems).length - itemCap).toString()})), 1)
                    ], 64))
              ], 8, _hoisted_4))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})